import {
  Box,
  Checkbox,
  CheckboxGroup,
  FormLabel,
  Text,
} from '@chakra-ui/react';
import React from 'react';
import { groupFilteredPlots } from '../../Services';
import { hexToRGB, lightenDarkenColor } from '../../Services/Formatters/Color';
import Base from './Base';
import FilterHeader from './FilterHeader';
import { sortStatusEntries } from '../../Services/Sort/SortStatusFilters';

export default class StatusFilter extends Base {
  constructor(props) {
    super(props);
    this.state = {
      hasClickedFilterAfterLoad: props.hasClickedFilterAfterLoad || false,
    };
  }

  handleChange = (event) => {
    let selected = {};
    this.setState({ hasClickedFilterAfterLoad: true });

    // Find the clicked key
    const currentlySelectedKeys = Object.keys(this.props.selected);
    const clickedKey =
      event.find((key) => !currentlySelectedKeys.includes(key)) ||
      currentlySelectedKeys.find((key) => !event.includes(key)) ||
      event[0];

    // Get all currently selected filters
    Object.keys(this.props.selected).forEach((key) => {
      selected[key] = this.props.values[key];
    });

    // Toggle the clicked filter (add if not present it should remove it)
    if (currentlySelectedKeys.includes(clickedKey)) {
      delete selected[clickedKey];
    } else {
      selected[clickedKey] = this.props.values[clickedKey];
    }

    return this.props.onChange(this.props.slug, selected);
  };

  render() {
    return (
      <>
        {this.props.label && (
          <FilterHeader
            label={this.props.label}
            resetCallback={this.resetCallback}
            filtersHaveChanged={this.filtersHaveChanged}
            showResetButton={true}
          />
        )}

        <CheckboxGroup
          onChange={(value) => this.handleChange(value)}
          defaultValue={Object.keys(this.props.default)}
          value={Object.keys(this.props.selected)}
          spacing={0}
        >
          <Box
            display={'flex'}
            flexDirection={['column', 'row']}
            gap={2}
            flexWrap={this.props.shouldNotWrap ? 'nowrap' : 'wrap'}
          >
            {sortStatusEntries(Object.entries(this.props.values)).map(
              (value) => {
                const active = Object.keys(this.props.selected).includes(
                  value[0]
                );

                // FIlter out the filters that have no items.
                const allPlotsArray = this.props.plots
                  ? Object.values(this.props.plots)
                  : [];
                const statusArray = groupFilteredPlots(allPlotsArray, 'status');
                const statusValue =
                  statusArray[value[0].split(' ').join('-').toLowerCase()];
                const statusResultsAmount = statusValue
                  ? statusValue.length
                  : 0;

                if (statusResultsAmount === 0) {
                  return null;
                }

                return (
                  <FormLabel
                    key={value[0]}
                    bg={active ? `${value[1]}` : 'transparent'}
                    border={`2px solid ${value[1]}`}
                    px={5}
                    py={2}
                    rounded={'2px'}
                    display={'flex'}
                    gap={1}
                    cursor={'pointer'}
                    spacing={0}
                    margin={0}
                    fontSize={'xs'}
                    justifyContent={'center'}
                    flex={'0 0 auto'}
                    userSelect={'none'}
                    opacity={1}
                    _hover={{
                      ...(() => {
                        const hoverColor = active
                          ? lightenDarkenColor(value[1], -20)
                          : hexToRGB(value[1], '0.7');
                        return {
                          bg: hoverColor,
                          borderColor: hoverColor,
                        };
                      })(),
                    }}
                    _focus={{
                      ...(() => {
                        if (active) {
                          const focusColor = lightenDarkenColor(value[1], -20);
                          return {
                            bg: focusColor,
                            borderColor: focusColor,
                          };
                        } else {
                          return {
                            bg: 'transparent',
                            borderColor: hexToRGB(value[1], '0.7'),
                          };
                        }
                      })(),
                    }}
                    _active={{
                      ...(() => {
                        if (active) {
                          const activeColor = lightenDarkenColor(value[1], -30);
                          return {
                            bg: activeColor,
                            borderColor: activeColor,
                          };
                        } else {
                          return {
                            bg: 'transparent',
                            borderColor: hexToRGB(value[1], '0.7'),
                          };
                        }
                      })(),
                    }}
                  >
                    <Text
                      as="span"
                      fontWeight={'bold'}
                      _firstLetter={{ textTransform: 'capitalize' }}
                    >
                      {value[0].replace('-', ' ')}
                    </Text>
                    <Text as="span">({statusResultsAmount})</Text>
                    <Checkbox
                      name={this.props.slug}
                      value={value[0]}
                      display="none"
                    />
                  </FormLabel>
                );
              }
            )}
          </Box>
        </CheckboxGroup>
      </>
    );
  }
}
